module.exports = __webpack_public_path__ + "img/img_1.00e814bd.jpg";